import { TokenService } from './../../shared/services/token.service';
import { LogoutService } from './../../login/services/logout.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private _logout: LogoutService, private _token: TokenService) {}

  canActivate() {
    if (this._token.comprobandoToken()) {
      return true;
    } else {
      this.router.navigate(['']);
      return false;
    }
  }
}
